import { SvgIcon, SvgIconProps } from "@mui/material";

export const DeleteIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M8.81 4.122c0-.208.169-.376.376-.376h5.628c.207 0 .375.168.375.376v1.5H8.811v-1.5Zm-1.5 1.5v-1.5c0-1.036.84-1.876 1.876-1.876h5.628c1.036 0 1.875.84 1.875 1.876v1.5h3.314a.75.75 0 0 1 0 1.5h-.556l-.912 11.861a3.001 3.001 0 0 1-2.992 2.77H8.457a3 3 0 0 1-2.992-2.77l-.912-11.86h-.556a.75.75 0 0 1 0-1.5H7.31Zm.75 1.5H6.057l.904 11.746c.06.782.712 1.386 1.496 1.386h7.086a1.5 1.5 0 0 0 1.496-1.386l.904-11.745H8.06Z"
        clip-rule="evenodd"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M13.97 10.874v5.628M10.03 10.874v5.628"
      />
    </svg>
  </SvgIcon>
);
